const huHU= {
    login: {
      title: 'Bejelentkezés',
      sign_in_btn: 'Bejelentkezés'
    },
    bar: {
        logout: 'Kijelentkezés',
        languages: 'Nyelvek',
        settings: 'Beállítások megnyitása'
    },
    language: {
      name: 'magyar (Magyarország)',
    },
    attributePage: {
        title: 'Tulajdonságok módosításai',
        viewChanges: 'Módosítások megtekintése',
        dateTime: 'Dátum',
        notificationType: 'Értesítés típusa',
        notificationValue: 'Értesítésben megadott érték',
        oldValue: 'Régi érték',
        newValue: 'Új érték',
        accept: 'Elfogadás',
        reject: 'Elutasítás',
    },
    Home: 'Kezdőoldal',
    load: 'Kezdeti betöltés folyamatban...',
    Requested: "Kért",
    Viewed: "Megtekintett",
    Executing: "Végrehajtás folyamatban",
    Completed: "Kitöltve",
    Expired: "Lejárt",
    Cancelled: "Megszakított",
    Error: "Hiba",
    Rejected: "Elutasított",
    error: 'Hiba lépett fel; kérjük, próbálja meg újra később.',
    displayname: 'Megjelenített név',
    givenname: 'Név',
    surname: 'Vezetéknév',
    email: 'E-mail-cím',
    mail: 'E-mail-cím',
    name: 'Név',
    firstname: 'Név',
    lastname: 'Vezetéknév',
    footer_copyright: 'Minden jog fenntartva.'
  };
  
  export default huHU;
  